export default __webpack_public_path__ + "static/Budny-59982bb2ea62d1fbdd411a710d1bd8bf.jpeg";